export function filterClassNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}
